<template>
  <div class="jo-publish">
    <h3 v-if="this.articlemeta.doi || this.articlemeta.clc && this.articlemeta.clc.length>0 || this.articlemeta.dc&&this.articlemeta.dc.length>0">
      {{ARTICLE.defaultlang=='zh'?'基本信息':'BASIC INFO'}}</h3>
    <p v-if="this.articlemeta.doi"><span class="publish-strong">DOI：</span>{{ this.articlemeta.doi }}</p>
    <p v-if="this.articlemeta.clc && this.articlemeta.clc.length>0">
      <span class="publish-strong">{{ARTICLE.defaultlang=='zh'?'中图分类号：':'CLC：'}}</span>
      <span v-for="(clc,index) in this.articlemeta.clc">
                  <component v-for="item in clc" :is="'jo' + item.name" v-bind:key="item.index"
                             v-bind:data="item.data"></component>{{index < articlemeta.clc.length-1 ? '；' : ''}}
      </span>
    </p>
    <p v-if="this.articlemeta.dc&&this.articlemeta.dc.length>0">
      <span class="publish-strong">{{ARTICLE.defaultlang=='zh'?'文献标识码：':'DC：'}}</span>
      <component :is="'jo' + item.name" v-for="item in this.articlemeta.dc" v-bind:key="item.index" v-bind:data="item.data"></component>
    </p>
    <div v-if="this.ARTICLE.qrcodeosid&&this.ARTICLE.qrcodeosid.graphic != ''">
      <h3 class="publish-strong">{{ARTICLE.defaultlang=='zh'?'开放科学（资源服务）标识码':'OSID CODE'}}</h3>
      <img style="height: 60px;width: 60px;margin-left: 2em" :src="ARTICLE.qrcodeosid.graphic.big"/>
    </div>
    <div v-for="responseItem in ARTICLE.response" v-if="responseItem.type == 'editor-note'">
      <h3>{{responseItem.title}}</h3>
      <component :is="'jo' + item.name" v-for="(item,index) in responseItem.data" v-bind:key="'editor-note' + index" v-bind:data="item.data"></component>
      <p v-if="responseItem.author && responseItem.author.length > 0 || responseItem.aff && responseItem.aff.length > 0">
        <span v-if="responseItem.author && responseItem.author.length > 0">{{responseItem.author[0]}}</span>&nbsp;&nbsp;
        <span v-if="responseItem.aff && responseItem.aff.length > 0">{{responseItem.aff[0]}}</span>
      </p>
    </div>

    <h3 v-if="articlemeta.citeme.length > 0 && articlemeta.citeme[0]!='' ||
              articlemeta.citeme.length > 1 && articlemeta.citeme[1]!=''">{{ARTICLE.defaultlang=='zh'?'引用信息':'CITATION'}}</h3>
    <p v-if="this.articlemeta.citeme.length > 0">
      <span class="citeme-content" ref="cite0">
        <component :is="'jo' + item.name" v-for="item in this.articlemeta.citeme[0].data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </span>
      <clipboard class="clipboard" :text="this.articlemeta.citeme[0].text" :imgurl="copyImgUrl"></clipboard>
    </p>
    <p v-if="this.articlemeta.citeme.length > 1">
      <span class="citeme-content" ref="cite1">
      <component :is="'jo' + item.name" v-for="item in this.articlemeta.citeme[1].data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </span>
      <clipboard class="clipboard" :text="this.articlemeta.citeme[1].text" :imgurl="copyImgUrl"></clipboard>
    </p>

    <div class="fundinggroup"
         v-if="this.articlemeta.hasOwnProperty('fundinggroup') && this.articlemeta.fundinggroup.length > 0">
      <h3>{{ARTICLE.defaultlang=='zh'?'基金信息':'FUNDING'}}</h3>
      <p><component :is="'jo' + item2.name" v-for="item2 in articlemeta.fundinggroup[0].text" v-bind:key="item2.index"
                    v-bind:data="item2.data"></component></p>
      <p v-if="this.articlemeta.fundinggroup.length > 1"><component :is="'jo' + item2.name" v-for="item2 in articlemeta.fundinggroup[1].text" v-bind:key="item2.index"
                                                                    v-bind:data="item2.data"></component></p>
    </div>
    <div class="jo-copyright"
         v-if="this.articlemeta.hasOwnProperty('copyright')">
      <h3>{{ARTICLE.defaultlang=='zh'?'版权信息':'PERMISSION'}}</h3>
      <p v-if="articlemeta.copyright.year">{{ARTICLE.defaultlang=='zh'?'版权年':'Permission year'}}：{{articlemeta.copyright.year}}</p>
      <p v-if="articlemeta.copyright.holder">{{ARTICLE.defaultlang=='zh'?'版权人':'Permission holder'}}：{{articlemeta.copyright.holder}}</p>
      <div class="jo-copyright-item" v-for="copyrightItem in articlemeta.copyright.data">
        <component :is="'jo' + item.name" v-for="item in copyrightItem.data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </div>
    </div>

    <h3 v-if="this.articlemeta.history && (articlemeta.history.epub || articlemeta.history.ppub || articlemeta.history.revised || articlemeta.history.accepted || articlemeta.history.received)">
      {{ARTICLE.defaultlang=='zh'?'稿件历史':'HISTORY'}}</h3>
    <p v-if="this.articlemeta.history.ppub && articlemeta.history.ppub!=''"><span class="publish-strong">{{ARTICLE.defaultlang=='zh'?'纸刊出版日期：':'Published：'}}</span>{{ this.articlemeta.history.ppub }}
    </p>
    <p v-if="this.articlemeta.history.epub && articlemeta.history.epub!=''"><span class="publish-strong">{{ARTICLE.defaultlang=='zh'?'网络出版日期：':'On-line：'}}</span>{{ this.articlemeta.history.epub }}
    </p>
    <p v-if="this.articlemeta.history.preprint && articlemeta.history.preprint!=''"><span class="publish-strong">{{ARTICLE.defaultlang=='zh'?'预印本：':'Preprint：'}}</span>{{ this.articlemeta.history.preprint }}
    </p>
    <p v-if="this.articlemeta.history.crosschecked && articlemeta.history.crosschecked!=''"><span class="publish-strong">{{ARTICLE.defaultlang=='zh'?'查重日期：':'Crosschecked：'}}</span>{{ this.articlemeta.history.crosschecked }}
    </p>
    <p v-if="this.articlemeta.history.accepted && articlemeta.history.accepted != ''"><span
      class="publish-strong">{{ARTICLE.defaultlang=='zh'?'接受日期：':'Accepted：'}}</span>{{ this.articlemeta.history.accepted }}</p>
    <p v-if="this.articlemeta.history.revised && articlemeta.history.revised != ''"><span
      class="publish-strong">{{ARTICLE.defaultlang=='zh'?'修回日期：':'Revised：'}}</span>{{ this.articlemeta.history.revised}}</p>
    <p v-if="this.articlemeta.history.received && articlemeta.history.received != ''"><span
      class="publish-strong">{{ARTICLE.defaultlang=='zh'?'收稿日期：':'Received：'}}</span>{{ this.articlemeta.history.received}}</p>
  </div>
</template>

<script>
  import clipboard from './clipboard.vue'
  import jofig from '../maincontent/body/fig/fig.vue'

  export default {
    components: {
      clipboard,
      jofig
    },
    data() {
      return {
        articlemeta: this.ARTICLE.articlemeta,
        copyImgUrl: require('../../assets/img/copy.png')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .jo-publish {
    background-color: #fafafa;
    position: relative;
    padding: 10px 10px 30px 20px;
    h3 {
      font-size: 1.8rem;
      font-weight: bold;
    }
    p {
      margin-left: 2em;
      line-height: 2.8rem;
      .publish-strong {
        color: #333333;
      }
      span {
        line-height: 24px;
      }
    }
    .clipboard {

      height: 14px;
      width: 12px;
      cursor: pointer;
    }
    .jo-copyright-item{
      font-size: 1.4rem;
      margin-bottom: 1.5rem;
      word-wrap: break-word;
      word-break: normal;
      letter-spacing: 0.03em;
      color: #333;
      margin-left: 2em;
      p{
        line-height: 2rem;
        margin-left: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/publish/publish.vue